<div class="w-screen">
  <div class="flex flex-nowrap overflow-auto px-5 gap-x-3">
    <div
      *ngFor="let proposition of filteredPropositions"
      class="w-full relative bg-white shadow-lg p-5 mb-5"
    >
      <div class="flex flex-col relative">
        <div
          class="w-[260px] h-20 rounded justify-center items-center inline-flex"
        >
          <img
            class="w-full h-full rounded object-cover"
            [src]="(proposition.images | first)?.thumb"
          />
        </div>
        <div
          class="w-[260px] text-slate-900 text-lg font-semibold leading-[normal] mt-2"
        >
          {{ proposition.title }}
        </div>
        <div
          class="w-[260px] text-zinc-600 text-sm font-normal leading-[18px] mt-2 line-clamp-4"
        >
          {{ proposition.description }}
        </div>

        <div
          *ngIf="proposition.isSubscribed"
          class="absolute top-[-15px] left-[-20px]"
          (click)="subscriptionChange(proposition, false)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="56"
            height="56"
            fill="none"
          >
            <g filter="url(#a)">
              <rect width="40" height="40" x="8" y="4" fill="#fff" rx="20" />
              <rect
                width="38"
                height="38"
                x="9"
                y="5"
                stroke="#F0CDD7"
                stroke-width="2"
                rx="19"
              />
              <path
                fill="#C83764"
                stroke="#C83764"
                stroke-width="2"
                d="M27.913 11.785a.1.1 0 0 1 .176 0l3.79 6.9a.1.1 0 0 0 .067.05l7.304 1.504a.1.1 0 0 1 .053.166l-5.305 5.716a.1.1 0 0 0-.025.085l1.325 7.976a.1.1 0 0 1-.144.105l-7.108-3.546a.1.1 0 0 0-.09 0l-7.108 3.547a.1.1 0 0 1-.144-.106l1.325-7.976a.1.1 0 0 0-.025-.085l-5.306-5.716a.1.1 0 0 1 .053-.166l7.305-1.503a.1.1 0 0 0 .067-.05l3.79-6.901Z"
              />
            </g>
            <defs>
              <filter
                id="a"
                width="56"
                height="56"
                x="0"
                y="0"
                color-interpolation-filters="sRGB"
                filterUnits="userSpaceOnUse"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  result="hardAlpha"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                  values="0 0 0 0 0.0784314 0 0 0 0 0.0980392 0 0 0 0 0.176471 0 0 0 0.04 0"
                />
                <feBlend
                  in2="BackgroundImageFix"
                  mode="multiply"
                  result="effect1_dropShadow_6289_156165"
                />
                <feBlend
                  in="SourceGraphic"
                  in2="effect1_dropShadow_6289_156165"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
        <div
          *ngIf="!proposition.isSubscribed"
          class="absolute top-[-15px] left-[-20px]"
          (click)="subscriptionChange(proposition, true)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="56"
            height="56"
            fill="none"
          >
            <g filter="url(#a)">
              <rect width="40" height="40" x="8" y="4" fill="#fff" rx="20" />
              <rect
                width="38"
                height="38"
                x="9"
                y="5"
                stroke="#C8C8CD"
                stroke-width="2"
                rx="19"
              />
              <path
                fill="#C8C8CD"
                stroke="#C8C8CD"
                stroke-width="2"
                d="M27.913 11.785a.1.1 0 0 1 .176 0l3.79 6.9a.1.1 0 0 0 .067.05l7.304 1.504a.1.1 0 0 1 .053.166l-5.305 5.716a.1.1 0 0 0-.025.085l1.325 7.976a.1.1 0 0 1-.144.105l-7.108-3.546a.1.1 0 0 0-.09 0l-7.108 3.547a.1.1 0 0 1-.144-.106l1.325-7.976a.1.1 0 0 0-.025-.085l-5.306-5.716a.1.1 0 0 1 .053-.166l7.305-1.503a.1.1 0 0 0 .067-.05l3.79-6.901Z"
              />
            </g>
            <defs>
              <filter
                id="a"
                width="56"
                height="56"
                x="0"
                y="0"
                color-interpolation-filters="sRGB"
                filterUnits="userSpaceOnUse"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  result="hardAlpha"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                  values="0 0 0 0 0.0784314 0 0 0 0 0.0980392 0 0 0 0 0.176471 0 0 0 0.04 0"
                />
                <feBlend
                  in2="BackgroundImageFix"
                  mode="multiply"
                  result="effect1_dropShadow_6289_156163"
                />
                <feBlend
                  in="SourceGraphic"
                  in2="effect1_dropShadow_6289_156163"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
      </div>
    </div>
    <div
      class="w-full relative bg-white shadow-lg mb-5"
      *ngIf="filteredPropositions | lessThanArray: propositions"
      (click)="onViewMore()"
    >
      <div
        class="flex flex-col relative items-center justify-center h-full w-[156px]"
      >
        <div>
          <svg
            width="86"
            height="74"
            viewBox="0 0 86 74"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d_6289_155862)">
              <rect x="18" width="50" height="50" rx="25" fill="#14192D" />
              <rect
                x="19"
                y="1"
                width="48"
                height="48"
                rx="24"
                stroke="white"
                stroke-width="2"
              />
              <g clip-path="url(#clip0_6289_155862)">
                <path
                  d="M39.1081 34.7331L48.875 25L39.1081 15.2669"
                  stroke="white"
                  stroke-width="2.5"
                />
              </g>
            </g>
            <defs>
              <filter
                id="filter0_d_6289_155862"
                x="0"
                y="-12"
                width="86"
                height="86"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="6" />
                <feGaussianBlur stdDeviation="9" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0784314 0 0 0 0 0.0980392 0 0 0 0 0.176471 0 0 0 0.16 0"
                />
                <feBlend
                  mode="multiply"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_6289_155862"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_6289_155862"
                  result="shape"
                />
              </filter>
              <clipPath id="clip0_6289_155862">
                <rect
                  width="26"
                  height="26"
                  fill="white"
                  transform="translate(31 12)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div
          class="text-right text-slate-900 text-[13px] font-bold uppercase leading-snug tracking-wide"
        >
          VIEW MORE
        </div>
      </div>
    </div>
  </div>
</div>
